import React from 'react'
import renderChildUIComponents from './metadata-mapper'
import classNames from 'classnames';
import { FlatDomainDataContext, FormBean, IUIContainerRowDef } from '../../datatypes';

const {MDBRow} = require('mdbreact');

interface ContainerRowProps {
    metadata:IUIContainerRowDef;
    formBean:FormBean;
    ctx:FlatDomainDataContext;
}

export default class ContainerRow extends React.Component<ContainerRowProps,{}> {

  render() {
    const {metadata} = this.props;
    let className = classNames("containerRow",metadata.cssClasses);

    return (
      <MDBRow className={className}>
        {
          renderChildUIComponents(this.props)
        }
      </MDBRow>
    )
  }
}